import Footer from './Footer';
import ScrollAnimation from './ScrollAnimation';

const Features = () => {
  const features = [
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "سرعة في الأداء",
      description: "نظام مصمم ليعمل بكفاءة عالية وسرعة استجابة فائقة، مما يضمن سلاسة العمليات حتى في أوقات الذروة."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "سهولة الاستخدام",
      description: "واجهة مستخدم بديهية وسهلة التعلم، لا تتطلب خبرة تقنية مسبقة، مما يقلل من وقت تدريب الموظفين."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
        </svg>
      ),
      title: "دفعات متعددة",
      description: "دعم شامل لجميع طرق الدفع الحديثة، بما في ذلك البطاقات الائتمانية، مدى، وآبل باي."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
        </svg>
      ),
      title: "تقارير متقدمة",
      description: "لوحة تحكم تحليلية تمنحك رؤى دقيقة حول مبيعاتك وأداء المخزون لاتخاذ قرارات مدروسة."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
      title: "يعمل دون انترنت",
      description: "استمر في البيع وإدارة عملياتك حتى عند انقطاع الاتصال، وتتم المزامنة تلقائياً عند عودة الإنترنت."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      title: "دعم فني 24/7",
      description: "فريق دعم متخصص جاهز لمساعدتك في أي وقت لضمان سير عملك دون توقف."
    }
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden" id="features">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-slate-50 transform -skew-y-3 origin-top-left -z-10 h-full w-full opacity-60"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-primary-500 font-bold tracking-wider uppercase text-sm mb-2 block">
            لماذا كاش تك؟
          </span>
          <h2 className="text-4xl font-bold text-slate-900 mb-6 leading-tight">
            كل ما تحتاجه لإدارة مشروعك <br className="hidden md:block" /> في <span className="text-primary-500">منصة واحدة</span>
          </h2>
          <p className="text-xl text-slate-600">
            صمم نظامنا ليكون شريكك في النجاح، موفراً لك الأدوات اللازمة للتحكم الكامل وتنمية أعمالك.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, index) => (
            <ScrollAnimation key={index} variant="fade-up" delay={index * 100}>
                <div 
                  className="group p-8 rounded-3xl bg-white border border-slate-100 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 relative overflow-hidden h-full"
                >
                  <div className="absolute top-0 right-0 w-24 h-24 bg-primary-100 rounded-bl-full -mr-4 -mt-4 transition-transform duration-500 group-hover:scale-150 group-hover:bg-primary-500/10"></div>
                  
                  <div className="w-14 h-14 bg-primary-500 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-primary-500/30 mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
                    {feature.icon}
                  </div>
                  
                  <h3 className="text-xl font-bold text-slate-900 mb-4 group-hover:text-primary-500 transition-colors">
                    {feature.title}
                  </h3>
                  
                  <p className="text-slate-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
